<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="onCancel()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">{{ "image_editing" | translate }}</h4>
</div>
<div class="modal-body">
    <sp-image-editor [image]="image" #imageEditor="image-editor"></sp-image-editor>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="onCancel()">{{ "cancel" | translate }}</button>
    <button type="button" class="btn btn-primary" (click)="onConfirm()">{{ "save" | translate }}</button>
</div>
